import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import cx from 'classnames';
import { setEmployeeFilters } from 'actionCreators';
import {
  getEmployeeList,
  getEmployeeLoading,
  getWorkroomList,
  getPhaseFiltersLocation,
} from '../../../../../../reducers';
import ReactSelect from 'components/StyledSelect/react_select';
import reactSelectStyles from 'components/ReactSelect/styles';
import phaseFilterStyles from 'phaseFilters.scss';
import { IC_ISM_POSITIONS } from 'config/constants';

class SupervisorQuickFilter extends Component {
  componentDidMount = () => {
    this.fetchEmployees();
  }

  componentDidUpdate(prevProps) {
    const prevWorkrooms = prevProps.workroomFilters || [];
    const currentWorkrooms = this.props.workroomFilters || [];

    // Refetch if workroom selection changed
    if (prevWorkrooms.length !== currentWorkrooms.length ||
        !prevWorkrooms.every((id, idx) => id === currentWorkrooms[idx])) {
      this.fetchEmployees();
    }
  }

  getOptions = () => {
    const { employees } = this.props;

    return (employees || []).map(employee => ({
      value: employee.id,
      label: `${employee.name} - ${employee.position || 'Employee'}`,
    }));
  }

  fetchEmployees = () => {
    const { workroomFilters, workrooms } = this.props;

    // Filter to only IFI workrooms
    const ifiWorkroomIds = (workrooms || [])
      .filter(w => w.vendor === 'IFI' && workroomFilters.includes(w.id))
      .map(w => w.id);

    // Build filters for requestEmployeeList
    const filters = {
      is_active: true,
      for_workrooms: ifiWorkroomIds,
      for_positions: IC_ISM_POSITIONS,
    };

    // Set filters in state and request (setEmployeeFilters handles reset and request)
    this.props.setEmployeeFilters(filters);
  }

  handleChange = (selectedOption) => {
    const employeeId = selectedOption ? selectedOption.value : null;
    if (this.props.onChange) {
      this.props.onChange(employeeId);
    }
  }

  render = () => {
    const { className, loading, filters } = this.props;

    const value = filters && filters.assigned_employee
      ? parseInt(filters.assigned_employee, 10)
      : null;
    const selectedValue = value ? this.getOptions().find(opt => opt.value === value) : null;

    // "Supervisor" is labeled as "Coordinator" in the UI since
    // that's more familiar to IFI users, but the value is still
    // stored as "supervisor_id" in the backend.
    return (<ReactSelect
      name="supervisor"
      className={cx(reactSelectStyles, phaseFilterStyles.selectWrapper, className)}
      label="Coordinator (IFI)"
      placeholder="Select Coordinator"
      options={this.getOptions()}
      value={selectedValue}
      onChange={this.handleChange}
      clearable
      isLoading={loading}
    />);
  }
}

SupervisorQuickFilter.defaultProps = {
  workroomFilters: [],
  employees: [],
  loading: false,
  filters: {},
  workrooms: [],
};

SupervisorQuickFilter.propTypes = {
  employees: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    position: PropTypes.string,
  })),
  loading: PropTypes.bool.isRequired,
  setEmployeeFilters: PropTypes.func.isRequired,
  workroomFilters: PropTypes.arrayOf(PropTypes.number),
  workrooms: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    vendor: PropTypes.string,
  })),
  filters: PropTypes.shape({
    assigned_employee: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  }),
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

const getEmployeeOptions = createSelector(
  getEmployeeList,
  employees => employees || [],
);

const mapStateToProps = (state) => {
  const phaseFilters = getPhaseFiltersLocation(state);
  const workroomFilters = phaseFilters.workroom || [];

  return {
    loading: getEmployeeLoading(state),
    employees: getEmployeeOptions(state),
    workroomFilters: Array.isArray(workroomFilters) ? workroomFilters : [],
    workrooms: getWorkroomList(state),
  };
};

const mapDispatchToProps = dispatch => ({
  setEmployeeFilters: filters => dispatch(setEmployeeFilters(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SupervisorQuickFilter);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseList/components/SupervisorQuickFilter.jsx